import { connect } from 'react-redux';
import RemoveParticipantDialog from './RemoveParticipantDialog';
import {
  currentClassRoomId,
  participants,
} from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, props) => {
  const spaceId = currentClassRoomId(state);
  const userData = participants(state, spaceId).find(
    (user) => user.id === props.userId
  );
  return {
    fullName: userData ? `${userData.firstName} ${userData.lastName}` : '',
  };
};

export default connect(mapStateToProps)(RemoveParticipantDialog);
